<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/budgetItemList' }">预算项目</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="addNews">新增</el-button>
                    <el-button size="small" plain @click="copy">复制</el-button>
                    <el-button size="small" plain @click="editDetails">编辑</el-button>
                    <el-button size="small" plain @click="amend(list.id)">删除</el-button>
                    <el-button size="small" plain @click="dialogCilck">调整预算</el-button>
                    <el-button size="small" v-if="list.status == 1" plain @click="colseCilck">关闭预算</el-button>
                    <el-button size="small" v-else plain @click="openCilck(list.rid)">打开预算</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="list" class="details" label-width="auto">
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="code：">
                                    <el-input v-model="list.code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="年：">
                                    <el-input v-model="list.period" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="名称：">
                                    <el-input v-model="list.name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="部门：">
                                    <div class="read_only read_only_link">
                                        <span @click="goDepartment(list.department_rid)">{{ list.department_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算科目：">
                                    <div class="read_only read_only_link">
                                        <span @click="goBudget(list.budget_subject_rid)">{{ list.budget_subject_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="控制范围：">
                                    <el-input
                                        v-model="list.control_scope_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="控制：">
                                    <el-input
                                        v-model="list.control_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="状态：">
                                    <div class="read_only">
                                        <span v-if="list.status == 2" style="color: red">{{ list.status_label }}</span>
                                        <span v-else style="color: green">{{ list.status_label }}</span>
                                        <span v-if="list.close_time" class="status_flex" style="color: red"
                                            >(关闭时间:{{ list.close_time }})</span
                                        >
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="负责人：">
                                    <div class="read_only read_only_link">
                                        <span @click="principalClick(list.principal_rid)">{{ list.principal_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="时效：">
                                    <el-input
                                        v-model="list.timeliness_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="分布类型：">
                                    <el-input
                                        v-model="list.distribution_type_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预算标准：">
                                    <el-input
                                        v-model="list.budget_standard"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算已完成：">
                                    <el-input
                                        v-model="list.budget_completed"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预算：">
                                    <el-input v-model="list.budget" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算已占用：">
                                    <el-input
                                        v-model="list.budget_occupied"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预算已释放：">
                                    <el-input
                                        v-model="list.budget_released"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算已冻结：">
                                    <el-input
                                        v-model="list.budget_frozen"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="预算未释放：">
                                    <el-input
                                        v-model="list.budget_tobe_released"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算可执行：">
                                    <el-input
                                        v-model="list.budget_executable"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="是否结转余额：">
                                    <el-input
                                        v-model="list.carry_balance_label"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <div class="space"></div>
                                <el-form-item label="部门编码：">
                                    <el-input
                                        v-model="list.department_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="department_rid：">
                                    <el-input
                                        v-model="list.department_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="负责人工号：">
                                    <el-input
                                        v-model="list.principal_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="principal_rid：">
                                    <el-input
                                        v-model="list.principal_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="预算科目代码：">
                                    <el-input
                                        v-model="list.budget_subject_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="budget_subject_rid：">
                                    <el-input
                                        v-model="list.budget_subject_rid"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row v-if="assistanceType == 2">
                            <el-col :span="12">
                                <el-form-item label="受益人：">
                                    <div class="read_only read_only_link">
                                        <span @click="beneficiaryClick(list.beneficiary_rid)">{{ list.beneficiary_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="受益人工号：">
                                    <el-input
                                        v-model="list.beneficiary_code"
                                        class="flex_item_text"
                                        size="mini"
                                        readonly="readonly"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="assistanceType == 4">
                            <el-col :span="12">
                                <el-form-item label="项目：">
                                    <el-input v-model="list.project_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                    <!-- <div class="read_only read_only_link"> <span @click="projectClick(list.project_rid)">{{ list.project_name }}</span> </div> -->
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="项目代码：">
                                    <el-input v-model="list.project_code" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="合作方：" v-if="assistanceType == 3">
                                    <el-input v-model="list.partner_name" class="flex_item_text" size="mini" readonly="readonly"></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="12">
                                <el-form-item label="供应商：" v-if="assistanceType == 5">
                                    <div class="read_only read_only_link">
                                        <span @click="supplierClick(list.supplier_rid)">{{ list.supplier_name }}</span>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="创建人：" prop="created_by">
                                    <div class="read_only">{{ list.created_by ? list.created_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="上次修改人：" prop="updated_by">
                                    <div class="read_only">{{ list.updated_by ? list.updated_by : '' }}</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="预算行" name="2">
                    <vBudgetLineComponent :postList="postList" v-if="flag"></vBudgetLineComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="预算来源" name="3">
                    <vBudgetSourceComponent :postList="postList1" v-if="flag1"></vBudgetSourceComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="预算执行行" name="4">
                    <vBudgetExecutionComponent :postList="postList2" v-if="flag2"></vBudgetExecutionComponent>
                </el-collapse-item>
                <el-collapse-item disabled title="每刻冻结中列表" name="5">
                    <vBudgetFreezingComponent :postList="postList3" v-if="flag3"></vBudgetFreezingComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import vBudgetLineComponent from '../../listComponent/budget/budgetLineComponent.vue';
import vBudgetSourceComponent from '../../listComponent/budget/budgetSourceComponent.vue';
import vBudgetExecutionComponent from '../../listComponent/budget/budgetExecutionComponent.vue';
import vBudgetFreezingComponent from '../../listComponent/budget/budgetFreezingComponent.vue';
export default {
    inject: ['reload'],
    name: 'budgetItemDetails',
    components: {
        vBudgetLineComponent,
        vBudgetSourceComponent,
        vBudgetExecutionComponent,
        vBudgetFreezingComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                setBtn: true,
                tableData: [],
                list: {}
            },
            flag: false,
            postList1: {
                headerTitle: false,
                setBtn: true,
                params: {
                    budget_item_rid: ''
                }
            },
            flag1: false,
            flag2: false,
            postList2: {
                headerTitle: false,
                searchBtn: true,
                resetBtn: true,
                setBtn: true,
                period: true,
                params: {
                    budget_item_rid: ''
                },
                budgetItemPeriod: ''
            },
            flag3: false,
            postList3: {
                headerTitle: false,
                setBtn: true,
                params: {
                    budget_item_rid: ''
                }
            },
            headerTitle: '预算项目详情',
            list: {},
            activeNames: ['1', '2', '3', '4', '5'],
            rid: '',
            assistanceType: ''
        };
    },
    mounted() {
        this.rid = this.$route.query.id;
        this.postList1.params.budget_item_rid = this.$route.query.id;
        this.postList2.params.budget_item_rid = this.$route.query.id;
        this.postList3.params.budget_item_rid = this.$route.query.id;
        this.getDetails(); //获取详情
        this.flag = false;
        this.flag1 = false;
        this.flag2 = false;
        this.flag3 = false;
        this.$nextTick(() => {
            this.flag = true;
            this.flag1 = true;
            this.flag2 = true;
            this.flag3 = true;
        });
    },
    watch: {
        $route(to, from) {
            this.rid = to.query.id;
            this.postList1.params.budget_item_rid = to.query.id;
            this.postList2.params.budget_item_rid = to.query.id;
            this.postList3.params.budget_item_rid = to.query.id;
            this.reload();
        }
    },
    methods: {
        //报销人 承担人详情
        principalClick(rid) {
            this.$router.push({
                path: 'personDetail',
                query: {
                    id: rid
                }
            });
        },
        //项目查看
        projectClick(rid) {
            // this.$router.push({
            //     path: 'contactDetail',
            //     query: {
            //         id: rid
            //     }
            // });
        },
        //受益人查看
        beneficiaryClick(rid) {
            this.$router.push({
                path: 'personDetail',
                query: {
                    id: rid
                }
            });
        },
        supplierClick(rid) {
            this.$router.push({
                path: 'accountDetails',
                query: {
                    id: rid
                }
            });
        },
        //预算科目跳转
        goBudget(rid) {
            this.$router.push({
                path: 'budgetAccountDetails',
                query: {
                    id: rid
                }
            });
        },
        //部门快速链接
        goDepartment(rid) {
            this.$router.push({
                path: 'departmentDetails',
                query: {
                    id: rid
                }
            });
        },
        //重新打开预算
        openCilck(rid) {
            var params = {
                rid: rid
            };
            let messages = '此操作将重新打开此条数据的预算，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '打开...';
                        this.$api
                            .budgetItemReOpen(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '打开成功',
                                        type: 'success'
                                    });
                                    this.getDetails(); //获取详情
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //关闭预算
        colseCilck() {
            var params = {
                rid: this.rid
            };
            let messages = '此操作将关闭此条数据的预算，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '关闭...';
                        this.$api
                            .budgetItemClose(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '关闭成功',
                                        type: 'success'
                                    });
                                    this.getDetails(); //获取详情
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //调整预算
        dialogCilck() {
            this.$router.push({
                path: 'budgetSourceEdit',
                query: {
                    type: 4,
                    id: this.rid,
                    name: this.list.name,
                    editType: 1,
                    status: this.list.status
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox({
                title: '消息',
                message: messages,
                showCancelButton: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                closeOnPressEscape: false,
                closeOnClickModal: false,
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        instance.confirmButtonLoading = true;
                        instance.confirmButtonText = '删除...';
                        this.$api
                            .budgetItemDelete(params)
                            .then((res) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                                if (res.code == 0) {
                                    this.$message({
                                        showClose: true,
                                        message: '删除成功',
                                        type: 'success'
                                    });
                                    this.$bus.$emit('fullPath', this.$route.fullPath);
                                    this.$router.push({
                                        path: '/budgetItemList'
                                    });
                                }
                            })
                            .catch((error) => {
                                done();
                                setTimeout(() => {
                                    instance.confirmButtonLoading = false;
                                }, 300);
                            });
                    } else {
                        done();
                    }
                }
            })
                .then((action) => action)
                .catch((error) => error);
        },
        //前往编辑页面
        editDetails() {
            this.$router.push({
                path: 'BudgetItemEdit',
                query: {
                    type: 1,
                    id: this.rid
                }
            });
        },
        //新增
        addNews() {
            this.$router.push({
                path: 'BudgetItemEdit',
                query: {
                    type: 3,
                    id: this.rid
                }
            });
        },
        //复制页面
        copy() {
            this.$router.push({
                path: 'BudgetItemEdit',
                query: {
                    type: 5,
                    id: this.rid
                }
            });
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/budgetItemList' });
            } else {
                this.$router.go(-1);
            }
        },
        //详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .budgetItemDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.list = res.data;
                        this.postList.tableData = res.data.lines;
                        this.postList.list = res.data;
                        this.assistanceType = res.data.budget_subject.assistance;
                        document.title = this.headerTitle + ':' + res.data.code;
                        this.postList2.budgetItemPeriod = res.data.period;
                    }
                })
                .catch((error) => {});
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>